/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * LESS_THAN operator looks for values that are less than the given value.
 */
export interface LessThanVersion {
    /** The value to compare against. */
    value: number;
}
